module.exports = __webpack_public_path__ + "img/AE5004-163.819eedc2.jpg";